import { UploadOutlined } from "@ant-design/icons";
import { CustomModal, ItemHelpButton } from "../../../components";
import { useHelpButtonReducer } from "../../../hooks/home/index";
import ItemDowloadCSV from "../../../components/ItemDowloadCSV";
// import { useSelector } from "react-redux";
// import { AddGroup } from "../../VrLearning/templates/AddGroup";
import { UpdateCampaing } from "../../VrLearning/templates/UpdateCampaing";
// import { AddStudents } from "../../VrLearning/templates/AddStudents";

export const HelpButtonsTraining = () => {
    const { setUpdateFileModal, state } = useHelpButtonReducer();
    // const { groups } = useSelector(state => state.vrlSlice)

    return (
        <div className="h-full w-[69px] flex flex-col items-center pt-[72px] ">
            {/* <ItemHelpButton disabled={false} key={"AddGroup-it"} title={"Agregar materia"} icon={<PlusOutlined className="text-white" />} openModal={setSubjectModal} />
            <CustomModal
                key={"AddGroup"}
                isVisible={state.addSubject}
                close={setSubjectModal}
                title={"Agregar materia"}
                width={"430px"}
                height={"192px"}
            >
                <AddGroup close={setSubjectModal} />
            </CustomModal> */}

            <ItemHelpButton disabled={false} key={"upload"} title={"Subir archivo"} icon={<UploadOutlined className="text-white" />} openModal={setUpdateFileModal} />
            <CustomModal
                key={"upload-modal"}
                isVisible={state.updateFile}
                close={setUpdateFileModal}
                title={"Agregar resultados"}
                width={"430px"}
                height={"520px"}
            >
                <UpdateCampaing close={setUpdateFileModal} />
            </CustomModal>
            {/* <ItemHelpButton
                key={"addStudents"}
                disabled={!(groups.length > 0)}
                title={"Agregar alumnnos"}
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white" className="w-6 h-6">
                        <path d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                    </svg>
                }
                openModal={setAddStudentModal}
            />
            <CustomModal
                key={"addstudents"}
                isVisible={state.addStudents}
                close={setAddStudentModal}
                title={"Agregar alumnos"}
                width={"860px"}
                margin_left={"6rem"}
                height={"454px"}
            >
                <AddStudents close={setAddStudentModal} />
            </CustomModal> */}

            <ItemDowloadCSV
                key={"exportCsv"}
                disabled={false}
                title={"Exportar .csv"}
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white" className="w-6 h-6">
                        <path d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                    </svg>
                }
            />
        </div>
    );
};
